import ShopPageSlider from "./shop-page-slider";

export default ShopPageSlider;